export default __webpack_public_path__ + "static/media/logistic.da201787.svg";